export default {
  CONTROLLER: '0x018fac06',
  LEGACY: '0x7ba18ba1',
  MULTICOIN: '0xf1cb7e06',
  TEXT_RECORD: '0x59d1d43c'
};
